import { useState, useEffect, useCallback } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { InputSelect, InputNumber } from "@2solve/tosolve-inputs";

const TYPE_OPTIONS = [
  { value: "uint", label: "uint" },
  { value: "int", label: "int" },
  { value: "float", label: "float" },
  { value: "string", label: "string" },
  { value: "hex", label: "hex" },
  { value: "bool", label: "bool" },
];

function EditMappingModal({
  show,
  onHide,
  onSubmit,
  isEditMode,
  t,
  input,
  initialItem,
  error,
  isButtonDisabled,
}) {
  const [formData, setFormData] = useState({});
  const [sessionKey, setSessionKey] = useState(0);

  useEffect(() => {
    if (show) {
      setFormData(
        initialItem ?? {
          input_id: null,
          data_type: null,
          input_code: null,
          byte_length: null,
          codec_id: null,
        },
      );
      setSessionKey((k) => k + 1);
    }
  }, [show]);

  const handleChange = useCallback((id, value) => {
    setFormData((prev) => ({ ...prev, [id]: value }));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Modal backdrop="static" centered size="lg" show={show} onHide={onHide}>
      <Modal.Header closeVariant="white" closeButton>
        <Modal.Title>
          {isEditMode ? "Editar Item" : "Adicionar nova relação"}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body key={sessionKey}>
          <Row>
            <Col>
              <InputSelect
                placeholder={t("Input")}
                id="input_id"
                type="select"
                options={input}
                isMultiple={false}
                selectAll={false}
                closeOnSelect={true}
                IsClearable={true}
                disabled={false}
                onChange={handleChange}
                value={formData?.input_id || ""}
                required={true}
              />
            </Col>
            <Col>
              <InputSelect
                required={true}
                placeholder={t("Tipo do dado")}
                id="data_type"
                type="select"
                options={TYPE_OPTIONS}
                isMultiple={false}
                selectAll={false}
                closeOnSelect={true}
                IsClearable={true}
                disabled={false}
                onChange={handleChange}
                value={formData?.data_type || ""}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <InputNumber
                required={true}
                id="input_code"
                type="int"
                placeholder={t("Codigo de input")}
                value={formData?.input_code || ""}
                onChange={handleChange}
              />
            </Col>
            <Col>
              {" "}
              <InputNumber
                required={true}
                id="byte_length"
                type="int"
                placeholder={t("Tamanho em bytes")}
                value={formData?.byte_length || ""}
                onChange={handleChange}
              />
            </Col>
          </Row>
          {error && <div className="text-danger">{error}</div>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" type="submit" disabled={isButtonDisabled}>
            {t("button_save")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default EditMappingModal;
